export const getApiBaseUrl = () => `${window.location.origin}/api`
